import React, { useEffect, useState } from 'react'
import { Container, Nav, Tab, Breadcrumb } from "react-bootstrap";
import CourseCard from '../../components/BugBounty/BugCouseCard';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import SecurityHeaders from '../../data/SecurityHeaders';
import ENDPOINT from '../../data/ENDPOINT';
import axios from 'axios';

const BugDetailsPage = () => {
  const params = useParams();
  const [program, setProgram] = useState({});
  const getDetails = async () => {
    try {
      const data = new FormData();
      data.append('id', params.id);
      const response = await axios.post(ENDPOINT + 'get-bounty-details.php', data, SecurityHeaders);
      if (response) {
        if (response.data.status === "success") {
          setProgram(response.data.data);
        } else {
          console.error('Failed to fetch bounty details');
        }
      }
    } catch (error) {
      console.error('Error fetching bounty details:', error);
    }
  }
  useEffect(() => {
    getDetails();
  }, []);
  // console.log(program);
  return (
    <div>


      <Container className="mt-4">


        <CourseCard bug={program} bounty_id={params.id} />

        {/* Tabs Section */}
        <Tab.Container defaultActiveKey="details">
          <Nav variant="tabs" className="mt-4">
            <Nav.Item>
              <Nav.Link className='text-dark' eventKey="details">Details</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="changelog">Changelog</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="announcements">Announcements</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="halloffame">Hall of Fame</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="mt-3 p-3 border mb-5">
            <Tab.Pane eventKey="details">
              <p>
                <strong>Vulnerabilities rewarded:</strong> 40
              </p>
              <p>
                <strong>Validation within:</strong> 4 days (75% of submissions are accepted or rejected within 4 days)
              </p>
              <p>
                <strong>Average payout:</strong> ${program.payout} (last 3 months)
              </p>
              <div className="mt-4  border rounded col-md-6 p-3 col-sm-12 col-xs-12 d-flex justify-content-between">
                <div>
                  <h5 className='text-dark' >P1</h5>
                  <p>{program.p1}</p>
                </div>
                <div>
                  <h5 className='text-dark'>P2</h5>
                  <p>{program.p2}</p>
                </div>
                <div>
                  <h5 className='text-dark'>P3</h5>
                  <p>{program.p3}</p>
                </div>

              </div>
              <p> {program.bounty_description}
              </p>
            </Tab.Pane>
            <Tab.Pane eventKey="changelog">
              <p>No recent changes.</p>
            </Tab.Pane>
            <Tab.Pane eventKey="announcements">
              <p>Latest announcements will be displayed here.</p>
            </Tab.Pane>
            <Tab.Pane eventKey="halloffame">
              <p>Top researchers and contributors will be displayed here.</p>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>
    </div>
  )
}

export default BugDetailsPage